function BuyTicketController() {
	'ngInject';

	// const vm = this;
}

export default BuyTicketController;



/** WEBPACK FOOTER **
 ** ./client/public/main/payment-ready/payment-ready.controller.js
 **/